<template>
	<div id="manual-data-list-view">
		<vx-card :noShadow="true">
			<div class="vx-row">
				<div class="vx-col w-full sm:w-1/1 lg:w-1/1 mb-base">
					<vx-card :noShadow="true" class="">
						<div class="flex justify-start flex-wrap">
							<feather-icon
								icon="FilePlusIcon"
								class="bg-white mr-2 rounded-full"
								svgClasses="w-16 h-16"
							></feather-icon>
							<div class="my-3 ml-3">
								<h5 class="mb-2">
									{{ $t("UploadFiles.UploadType") }} :
									{{ uploadFile.category }}
								</h5>
								<h5>{{ $t("ManualData.AddedOn") }} : {{ uploadFile.added_on }}</h5>
							</div>
						</div>

						<vs-divider></vs-divider>
						<div class="flex justify-between flex-wrap">
							<span>
								<p class="text-xl">{{ $t("Name") }} : {{ uploadFile.original_name }}</p>
								<p class="text-xl">
									{{ $t("ResourceModule.Table.Status") }} : {{ uploadFile.process_state }}
								</p>
								<p class="mt-2 text-danger" v-if="dataFiles.length > 0">
									{{ $t("ManualData.ErrorsFound") }}
								</p>
								<p class="mt-2 text-success" v-else>
									{{ $t("ManualData.ErrorsNotFound") }}
								</p>
							</span>
							<span>
								<vs-button
									v-if="isFileOnFirebase"
									@click="download"
									class="mt-4 mr-2 shadow-lg"
									type="gradient"
									color="#111350"
									gradient-color-secondary="#111350"
									>{{ $t("ManualData.DownloadFile") }}</vs-button
								>
								<vs-button
									v-if="isFileOnFirebase"
									@click="handleProcessAgain"
									class="mt-4 mr-2 shadow-lg"
									type="gradient"
									color="#28C76F"
									gradient-color-secondary="#28C26F"
									>{{ $t("ManualData.ProcessAgain") }}</vs-button
								>
								<vs-button class="mt-4" type="border" @click="handleBack">{{ $t("Back") }}</vs-button>
							</span>
						</div>
					</vx-card>
				</div>
			</div>
			<vs-table
				v-if="dataFiles.length > 0"
				ref="table"
				:multiple="false"
				v-model="selected"
				pagination
				:max-items="itemsPerPage"
				search
				:data="dataFiles"
			>
				<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
					<!-- ITEMS PER PAGE -->
					<vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
						<div
							class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
						>
							<span class="mr-2"
								>{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
								{{
									dataFiles.length - currentPage * itemsPerPage > 0
										? currentPage * itemsPerPage
										: dataFiles.length
								}}
								of {{ queriedItems }}</span
							>
							<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
						</div>
						<vs-dropdown-menu>
							<vs-dropdown-item @click="itemsPerPage = 4">
								<span>4</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="itemsPerPage = 10">
								<span>10</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="itemsPerPage = 15">
								<span>15</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="itemsPerPage = 20">
								<span>20</span>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
				</div>

				<template slot="thead">
					<vs-th sort-key="category">{{ $t("Description") }}</vs-th>
					<vs-th>{{ $t("ResourceModule.Table.Actions") }}</vs-th>
				</template>

				<template slot-scope="{data}">
					<tbody>
						<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
							<vs-td>
								<!-- Collapse -->
								<manual-data-list-item
									ref="ManualDataListItem"
									:data="tr"
									:edit="edit"
									@resolveManualDataEmit="resolveManualData"
								/>
							</vs-td>

							<vs-td class="whitespace-no-wrap">
								<feather-icon
									:title="$t('ManualData.ShowErrors')"
									icon="AlertTriangleIcon"
									svgClasses="w-5 h-5 text-danger stroke-current"
									@click.stop="toggleManualDataItem(indextr)"
								/>
								<feather-icon
									:title="$t('ManualData.FixErrorsHere')"
									v-if="uploadfileUpdatePermission"
									class="ml-2"
									icon="EditIcon"
									svgClasses="w-5 h-5 hover:text-primary stroke-current"
									@click.stop="changeEdit(indextr)"
								/>

								<feather-icon
									:title="$t('ManualData.FixErrorsModule')"
									class="ml-2"
									v-if="uploadfileUpdatePermission"
									icon="ExternalLinkIcon"
									svgClasses="w-5 h-5 hover:text-primary stroke-current"
									@click.stop="editData(tr)"
								/>

								<feather-icon
									:title="$t('ManualData.SaveChanges')"
									class="ml-2"
									style="display: none"
									icon="SaveIcon"
									svgClasses="w-5 h-5 hover:text-primary stroke-current"
									@click.stop="save(indextr)"
									ref="BtnSave"
								/>

								<feather-icon
									:title="$t('Crud.Delete')"
									v-if="uploadfileDeletePermission"
									icon="TrashIcon"
									svgClasses="w-5 h-5 hover:text-danger stroke-current"
									class="ml-2"
									@click.stop="openConfirm(tr.id)"
								/>
							</vs-td>
						</vs-tr>
					</tbody>
				</template>
			</vs-table>
		</vx-card>
		<vs-popup :title="popupTitle" :active.sync="popupActiveAlert">
			<alert size="small" :title="alert_title" :message="alert_message" :color="alert_color"></alert>
		</vs-popup>
	</div>
</template>

<script>
import vSelect from "vue-select";
import moduleManualData from "@/store/manual-data/moduleManualData";
import UploadedFile from "@/models/UploadedFile.js";
import VisitPoint from "@/models/VisitPoint.js";
import Vehicle from "@/models/Vehicle.js";
import ManualDataListItem from "./ManualDataListItem.vue";
import {downloadFileFromFirebase} from "@/helpers/firebaseDB.js";
import Commons from "@/helpers/commons.js";
import Alert from "@/components/alerts/Alert.vue";

export default {
	components: {
		ManualDataListItem,
		vSelect,
		Alert,
	},
	props: {
		customConfig: {
			type: Object,
			default: () => {
				return {
					actionDropdown: true,
					btnAssigGroup: false,
					columns: ["name", "description", "address", "hour_init", "hour_end", "action"],
				};
			},
		},
	},
	data() {
		return {
			selected: [],
			files: [],
			itemsPerPage: 10,
			isMounted: false,
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			currentPageLocal: 1,
			quantityElementPage: 10,
			groupDelete: null,
			dataId: 0,
			uploadFile: new UploadedFile({}),
			edit: false,
			popupActiveAlert: false,
			alert_title: "",
			alert_message: "",
			alert_color: "",
			popupTitle: "",
			fixManualdata: false,
			manualDataRegister: null,
			isFileOnFirebase: false,
		};
	},
	computed: {
		uploadfileDeletePermission() {
			return this.$store.getters.checkPermission("UPLOAD_FILES_D");
		},
		uploadfileUpdatePermission() {
			return this.$store.getters.checkPermission("UPLOAD_FILES_U");
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		dataFiles() {
			return this.$store.state.moduleManualData.issues;
		},
		queriedItems() {
			return this.$refs.table ? this.$refs.table.queriedResults.length : this.dataFiles.length;
		},
	},
	methods: {
		handleBack() {
			this.$router.go(-1);
		},
		manageErrorAlert(err) {
			const {title, text} = Commons.manageErrorValidator.call(this, err);
			const findErrorNameProperty = Commons.findErrorNamePropertyValidator();
			const nameProperty = findErrorNameProperty(err);
			this.alert_title = `${title}`;
			this.alert_message = `${this.$t("ManualData.PropertyError")} ${nameProperty}: ${text}`;
			this.alert_color = "danger";
			this.popupActiveAlert = true;
		},
		validateErrorRegister(error) {
			if (error.data === null || error.data === undefined) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("VisitPoints.ErrorRegisterValidate.Title"),
					text: this.$t("VisitPoints.ErrorRegisterValidate.Text"),
				});
				return;
			}
			if (error.data.reason.length > 0) {
				let reason = Array.from(new Set(error.data.reason.flatMap(({absolute_path}) => absolute_path)));
				let reasonFiltered = reason
					.filter((m) => m !== "additional_info")
					.map((m) => `${m.toUpperCase()}: ${this.$t("Routing.Messages.ValidatorRequiredProperty")} `)
					.join("; ");
				this.$vs.notify({
					color: "danger",
					title: this.$t("VisitPoints.ErrorRegisterValidate.Title"),
					text: reasonFiltered,
					time: 6000,
				});
			}
		},
		toggleManualDataItem(item) {
			this.$refs.ManualDataListItem[item].toggleFeatures();
		},
		changeEdit(item) {
			this.$refs.ManualDataListItem[item].changeEditMode();
			if (this.$refs.BtnSave[item].style.display === "none") {
				this.$refs.BtnSave[item].style.display = "inherit";
			} else {
				this.$refs.BtnSave[item].style.display = "none";
			}
		},
		save(item) {
			this.$refs.ManualDataListItem[item].getData();
		},
		resolveManualData(resolvedData) {
			this.fixManualdata = true;
			this.manualDataRegister = resolvedData;
			if (this.uploadFile.category === "VISIT_POINT_MASSIVE") {
				this.resolveManualVisitpoint(resolvedData);
			} else if (this.uploadFile.category === "VEHICLE_MASSIVE") {
				this.resolveManualVehicle(resolvedData);
			}
		},
		resolveManualVisitpoint({register, id}) {
			this.openLoading();
			this.$store
				.dispatch("moduleVisitPoint/save", register)
				.then((res) => {
					this.closeLoading();
					this.$store.dispatch("moduleManualData/removeManualdataItem", id);
					this.$vs.notify({
						color: "success",
						title: this.$t("VisitPoints.Success.Title"),
						text: this.$t("VisitPoints.Success.Text"),
					});
					return res;
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorAlert(err);
				});
		},
		resolveManualVehicle({register, id}) {
			this.openLoading();
			register["max_travel_distance"] = parseInt(register.max_travel_distance) || null;
			register["init_depot_id"] = register.init_depot_id ? parseInt(register.init_depot_id) : null;
			register["end_depot_id"] = register.end_depot_id ? parseInt(register.end_depot_id) : null;
			register["costs"] = register.costs
				? {
						time: parseFloat(register.costs.time),
						traveled_hour: parseFloat(register.costs.traveled_hour),
						distance: parseFloat(register.costs.distance),
						fixed: parseFloat(register.costs.fixed),
				  }
				: {time: 0, traveled_hour: 0, distance: 0, fixed: 0};
			this.$store
				.dispatch("vehicle/save", register)
				.then((res) => {
					this.closeLoading();
					this.$store.dispatch("moduleManualData/removeManualdataItem", id);
					this.$vs.notify({
						color: "success",
						title: this.$t("Vehicles.Success.Title"),
						text: this.$t("Vehicles.Success.Text"),
					});
					return res;
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorAlert(err);
				});
		},
		deleteRecord() {
			this.openLoading();
			this.$store
				.dispatch("moduleManualData/removeManualdataItem", this.dataId)
				.then((res) => {
					this.showDeleteSuccess();
				})
				.catch((err) => {
					this.closeLoading();
					if (err.response.status === 404) {
						return;
					}
				});
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		enableHeadTable(headName) {
			return this.customConfig.columns.includes(headName);
		},
		showDeleteSuccess() {
			this.closeLoading();
			this.$vs.notify({
				color: "success",
				title: this.$t("Record.TitleConfirmRecordDelete"),
				text: this.$t("Record.TextConfirmRecordDelete"),
			});
		},
		openConfirm(id) {
			this.dataId = id;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Record.DeleteRecord"),
				text: this.$t("Record.DeleteRecordConfirmText"),
				accept: this.deleteRecord,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		editData(object) {
			//  creacion de un punto de vista
			const {category_id, typology_id, typology_name} = {
				...this.uploadFile,
			};
			const datos = {
				...object.register,
				category_id,
				typology_id,
				typology_name,
			};

			if (this.uploadFile.category === "VEHICLE_MASSIVE") {
				const vehicle = new Vehicle(datos);
				this.$router.push({
					name: "app-vehicle-create",
					params: {
						vehicle_data: vehicle,
						manual_data_id: object.id,
						upload_file_id: object.upload_file_id,
					},
				});
			} else if (this.uploadFile.category === "VISIT_POINT_MASSIVE") {
				const visitPoint = new VisitPoint(datos);
				this.$router.push({
					name: "app-visit-point-create",
					params: {
						visit_point: visitPoint,
						manual_data_id: object.id,
						upload_file_id: object.upload_file_id,
					},
				});
			}
		},
		cahngeCurrentPageLocal() {
			this.currentPageLocal = 1;
		},
		handleProcessAgain() {
			this.openConfirmAgain();
		},
		openConfirmAgain() {
			this.$vs.dialog({
				type: "confirm",
				color: "primary",
				title: this.$t("ManualData.ProcessAgain"),
				text: this.$t("ManualData.ProcessAgainText"),
				accept: this.processAgain,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		processAgain() {
			const url = this.uploadFile.bucket_path;
			if (!url) return;

			const payload = {
				bucket_path: url,
				original_name: this.uploadFile.original_name,
				typology_id: this.uploadFile.typology_id,
				public: true,
				category: this.uploadFile.category,
			};
			this.openLoading();
			downloadFileFromFirebase(url)
				.then((res) => {
					return this.$store.dispatch("uploadFile/saveUploadFile", payload);
				})
				.then((res) => {
					this.closeLoading();
					this.$vs.notify({
						color: "success",
						title: this.$t("ManualData.ProcessAgain"),
						text: this.$t("ManualData.ProcessAgainTextSuccess"),
						time: 6000,
					});
				})
				.catch((error) => {
					this.closeLoading();
					this.processFirebaseError(error);
				});
		},
		download() {
			const url = this.uploadFile.bucket_path;
			if (!url) return;
			downloadFileFromFirebase(url)
				.then(async (res) => {
					await this.uploadFile.downloadFile(this.uploadFile.original_name, res);
				})
				.catch((error) => {
					this.processFirebaseError(error);
				});
		},
		processFirebaseError(error) {
			let msg = "";
			if (error.code && error.code === "storage/object-not-found") {
				msg = `El Archivo ${this.uploadFile.bucket_path} no fue encontrado`;
			} else {
				msg = this.$t("ErrorMessage");
			}
			this.$vs.notify({
				color: "danger",
				title: this.$t("ErrorTitle"),
				text: msg,
				time: 5000,
			});
		},
		existFile() {
			const url = this.uploadFile.bucket_path;
			if (!url) return;
			downloadFileFromFirebase(url)
				.then((res) => {
					this.isFileOnFirebase = true;
				})
				.catch((error) => {
					this.isFileOnFirebase = false;
				});
		},
	},
	watch: {
		itemsPerPage() {
			this.currentPageLocal = 1;
		},
	},
	created() {
		if (!moduleManualData.isRegistered) {
			this.$store.registerModule("moduleManualData", moduleManualData);
			moduleManualData.isRegistered = true;
		}
		this.$store.commit("moduleManualData/SET_ISSUES", []);
		const payload = {
			id: [this.$route.params.id],
		};
		this.openLoading();
		this.$store
			.dispatch("uploadFile/getUploadFilter", payload)
			.then((res) => {
				this.uploadFile = new UploadedFile(res.records[0]);
				if (this.uploadFile.id > 0) {
					const payload = {
						upload_file_id: [this.uploadFile.id],
					};
					return this.$store.dispatch("moduleManualData/fetchManualDataFilter", payload);
				} else {
					return [];
				}
			})
			.then((res) => {
				this.closeLoading();
				this.existFile();
			})
			.catch((err) => {
				this.closeLoading();
			});
	},
	mounted() {
		this.isMounted = true;
	},
};
</script>

<style lang="scss">
#manual-data-list-view {
	.vs-con-table {
		/*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.product-name {
			max-width: 23rem;
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 1.5rem;
			margin-right: 1.5rem;
			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			border-collapse: separate;
			border-spacing: 0 1.3rem;
			padding: 0 1rem;

			tr {
				box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
				td {
					padding: 2px;
					&:first-child {
						border-top-left-radius: 0.5rem;
						border-bottom-left-radius: 0.5rem;
					}
					&:last-child {
						border-top-right-radius: 0.5rem;
						border-bottom-right-radius: 0.5rem;
					}
				}
				td.td-check {
					padding: 10px !important;
				}
			}
		}

		.vs-table--thead {
			th {
				padding-top: 0;
				padding-bottom: 0;

				.vs-table-text {
					text-transform: uppercase;
					font-weight: 600;
				}
			}
			th.td-check {
				padding: 0 15px !important;
			}
			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}

.vs-popup--content-custom {
	.vs-popup--content {
		height: 100%;
	}
	.btn-save {
		position: absolute;
		left: calc(100vw - 10%);
		bottom: 30px;
	}
	.btn-del {
		position: absolute;
		left: 200px;
		bottom: 30px;
	}
}
</style>
